var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9997 68.64C57.9541 68.64 73.3197 53.2744 73.3197 34.32C73.3197 15.3656 57.9541 0 38.9997 0C20.0453 0 4.67969 15.3656 4.67969 34.32C4.67969 43.2429 8.08488 51.3705 13.6666 57.4741C14.3859 58.2607 14.8197 59.2749 14.8197 60.3408V73.1872C14.8197 76.1365 17.9027 78.0717 20.5587 76.7894L37.415 68.6519C37.4248 68.6472 37.4246 68.6332 37.4147 68.6288C37.4018 68.623 37.4064 68.6037 37.4205 68.6043C37.9439 68.628 38.4704 68.64 38.9997 68.64Z",
    fill: "#CC561E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8691 36.5652C35.8691 38.222 37.2123 39.5652 38.8691 39.5652H39.13C40.7869 39.5652 42.13 38.222 42.13 36.5652L42.13 23.0869C42.13 21.4301 40.7869 20.0869 39.13 20.0869H38.8691C37.2123 20.0869 35.8691 21.4301 35.8691 23.0869V36.5652ZM38.9996 47.913C40.7285 47.913 42.13 46.5115 42.13 44.7826C42.13 43.0537 40.7285 41.6521 38.9996 41.6521C37.2707 41.6521 35.8691 43.0537 35.8691 44.7826C35.8691 46.5115 37.2707 47.913 38.9996 47.913Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.13594e3108dfafa32f7d399e209f723c.svg";
export { ForwardRef as ReactComponent };